import style from "./style.module.sass"
import { useTheme } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import config from "../../../../config"

export default function LanguageLevelBar() {
    const { theme: { bgColors, colors } } = useTheme()
    const { t } = useTranslation()
    const resultData = useSelector(state => state.analyseData.result.resultData)
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    const benchmarkSettings = useSelector(state => state.analyseData.result.benchmark)
    const showCompliance = benchmarkSettings?.settings?.dataCompliance?.values?.enabled
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const languageLevel = resultData.formulaLanguageLevel || -1
    const languageLevelToString = config.languageLevelToString
    const textLanguageLevel = languageLevelToString.find(v => v.threshold < languageLevel)

    return <div className={style.firstPart} title={t('accessibility_analysis_language-level')} tabIndex={config.tabIndexes.languageLevelBarWrapper} style={{ backgroundColor: bgColors.bgPrimary0, padding: '8px 22px 8px', gridGap: '4px', flex: 1 }}>
    <p style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }} className={`${style.title}`}>{t("ai_gen_lang_level")}</p>
    <div className="d-flex align-items-center justify-content-center" >
        <h2 style={{ color: isContrast ? colors.colorContrast : textLanguageLevel ? textLanguageLevel.color : colors.colorPrimary700, fontSize: showCompliance ? '1.4rem' : '3rem' }} >
            {textLanguageLevel ? textLanguageLevel.level : ''}
        </h2>
    </div>
</div>
}